import domain from './domain';

// Reset task message template categories
export const resetTaskMessageTemplateCategories = domain.createEvent('resetTaskMessageTemplateCategories');

// Reset task messages
export const resetTaskMessages = domain.createEvent('resetTaskMessages');
